import { fetchListAll } from '@/api/employee'
export default {

    namespaced: true,

    state() {
        return {
            loading: false,
            list: [], // 员工列表
            recentSelectedList: [], // 最近选中
            sortType: 'sort', // 部门排序方式
        }
    },


    mutations: {
        setLoading(state, payload) {
            state.loading = payload
        },
        setList(state, payload) {
            state.list = payload
        },
        setRecentSelectedList(state, payload) {
            window.localStorage.setItem('employee-selector-all-recent-selected-list', JSON.stringify(payload)) // 将最近选中的数据存储在 localStorage 中
            state.recentSelectedList = payload;
        },
        setSortType(state, payload) {
            window.localStorage.setItem('dept-sort-type', payload)
            state.sortType = payload;
        }
    },

    actions: {
        getList({ commit }) {
            return new Promise((resolve) => {
                commit('setLoading', true)
                fetchListAll({}).then(res => {
                    console.log("res::::",res)
                    let list = [];
                    if (Array.isArray(res)) {
                        list = res;
                    } else if (res && Array.isArray(res.list)) {
                        list = res.list;
                    }
                    // 统一补全页面所需字段
                    list = list.map(item => {
                        const deptUniqueName = item.deptUniqueName || item.deptName || '';
                        return {
                            ...item,
                            deptUniqueName,
                            userId: item.userId || item.id,
                            instituteType: item.instituteType || 'branch',
                            employeeOrgVo: item.employeeOrgVo || { sort: 0, functionDeptSort: 0 }
                        };
                    });
                    commit('setList', Object.freeze(list))
                    resolve();
                }).finally(() => {
                    commit('setLoading', false)
                })
            })


        }
    }

}
